<template>
    <Head title="Applicant Training"></Head>
    <div class="grid">
        <div class="col-12">
            <div class="card">
                <Toast />
                <Toolbar class="mb-4">
                    <template v-slot:start>
                        <Button
                            label="Input New Overtime"
                            icon="pi pi-envelope"
                            class="p-button-primary mr-2"
                            @click="modalDialog"
                        />
                    </template>
                </Toolbar>
                <DataTable
                    ref="dt"
                    :value="models"
                    :lazy="true"
                    dataKey="id"
                    v-model:selection="selectedModels"
                    :paginator="true"
                    :rows="10"
                    :loading="loading"
                    :total-records="totalRecords"
                    v-model:filters="filters"
                    paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
                    :rowsPerPageOptions="[5, 10, 25]"
                    currentPageReportTemplate="Showing {first} to {last} of {totalRecords} models"
                    responsiveLayout="scroll"
                    @row-select="onRowSelect"
                    @row-unselect="onRowUnselect"
                    @page="onPage($event)"
                    @sort="onSort($event)"
                >
                    <template #header>
                        <div
                            class="flex flex-column md:flex-row md:justify-content-between md:align-items-center"
                        >
                            <h5 class="m-0">Manage Pengajuan Lembur</h5>
                            <span class="block mt-2 md:mt-0 p-input-icon-left">
                                <i class="pi pi-search" />
                                <InputText
                                    @change="onFilter($event)"
                                    v-model="filters['global'].value"
                                    placeholder="Search..."
                                />
                            </span>
                        </div>
                    </template>

                    <Column
                        selectionMode="multiple"
                    ></Column>
                    <Column
                        field="user.name"
                        header="Nama Karyawan"
                        :sortable="true"
                        headerStyle="width:50%;"
                    >
                        <template #body="slotProps">
                            <span class="p-column-title">Nama Karyawan</span>
                            {{ slotProps.data.user.name }}
                        </template>
                    </Column>
                    <Column
                        field="tanggal"
                        header="Tanggal"
                        :sortable="true"
                        headerStyle="width:50%;"
                    >
                        <template #body="slotProps">
                            <span class="p-column-title">Tanggal</span>
                            {{ slotProps.data.tanggal.value }}
                        </template>
                    </Column>
                    <Column
                        field="status"
                        header="Status"
                        :sortable="true"
                        headerStyle="width:50%;"
                    >
                        <template #body="slotProps">
                            <span class="p-column-title">Status</span>
                            {{ slotProps.data.status }}
                        </template>
                    </Column>
                    <Column headerStyle="width:50%;">
                        <template #body="slotProps">
                            <div class="flex gap-2">
                                <Button
                                    icon="pi pi-pencil"
                                    class="p-button-rounded p-button-success mr-2"
                                    @click="editDialog(slotProps.data)"
                                />
                                <Button
                                    icon="pi pi-trash"
                                    class="p-button-rounded p-button-danger"
                                    @click="confirmDeleteModel(slotProps.data)"
                                />
                            </div>
                        </template>
                    </Column>
                </DataTable>

                <Dialog
                    v-model:visible="ModalDialog"
                    :style="{ width: '450px' }"
                    header="Data Lembur"
                    :modal="true"
                    class="p-fluid"
                >

                    <div class="field">
                        <label for="tanggal">Tanggal Mulai</label>
                        <Calendar id="tanggal" v-model="model.tanggal_mulai" :inline="true" />
                        <small
                            class="p-invalid"
                            v-if="submitted && !model.tanggal_mulai"
                            >Tanggal Mulai is required.</small
                        >
                    </div>
                    <div class="field">
                        <label for="tanggal">Tanggal</label>
                        <Calendar id="tanggal" v-model="model.tanggal_akhir" :inline="true" />
                        <small
                            class="p-invalid"
                            v-if="submitted && !model.tanggal_akhir"
                            >Tanggal akhir is required.</small
                        >
                    </div>
                    <div class="field">
                        <label for="name">Lokasi Lembur</label>
                        <Dropdown v-model="model.location" :options="locations" optionLabel="location_name" placeholder="Pilih Lokasi" />
                        <small class="p-invalid" v-if="submitted && !model.location"
                            >Location is required.</small
                        >
                    </div>
                    <template #footer>
                        <Button
                            label="Cancel"
                            icon="pi pi-times"
                            class="p-button-text"
                            @click="hideDialog"
                        />
                        <Button
                            label="Save"
                            icon="pi pi-check"
                            class="p-button-text"
                            @click="save"
                        />
                    </template>
                </Dialog>

                <Dialog
                    v-model:visible="editModalDialog"
                    :style="{ width: '450px' }"
                    header="Data Lembur"
                    :modal="true"
                    class="p-fluid"
                >

                    <div class="field">
                        <label for="tanggal">Tanggal</label>
                        <Calendar id="tanggal" v-model="model.tanggal" :inline="true" />
                        <small
                            class="p-invalid"
                            v-if="submitted && !model.tanggal"
                            >Tanggal is required.</small
                        >
                    </div>
                    <template #footer>
                        <Button
                            label="Cancel"
                            icon="pi pi-times"
                            class="p-button-text"
                            @click="hideDialog"
                        />
                        <Button
                            label="Save"
                            icon="pi pi-check"
                            class="p-button-text"
                            @click="editSave"
                        />
                    </template>
                </Dialog>

                <Dialog
                    v-model:visible="deleteModelDialog"
                    :style="{ width: '450px' }"
                    header="Confirm"
                    :modal="true"
                >
                    <div class="flex align-items-center justify-content-center">
                        <i
                            class="pi pi-exclamation-triangle mr-3"
                            style="font-size: 2rem"
                        />
                        <span v-if="model"
                            >Are you sure you want to delete
                            <b>{{ model.name }}</b
                            >?</span
                        >
                    </div>
                    <template #footer>
                        <Button
                            label="No"
                            icon="pi pi-times"
                            class="p-button-text"
                            @click="deleteModelDialog = false"
                        />
                        <Button
                            label="Yes"
                            icon="pi pi-check"
                            class="p-button-text"
                            @click="deleteModel"
                        />
                    </template>
                </Dialog>

                <Dialog
                    v-model:visible="deleteModelsDialog"
                    :style="{ width: '450px' }"
                    header="Confirm"
                    :modal="true"
                >
                    <div class="flex align-items-center justify-content-center">
                        <i
                            class="pi pi-exclamation-triangle mr-3"
                            style="font-size: 2rem"
                        />
                        <span v-if="model"
                            >Are you sure you want to delete the selected
                            models?</span
                        >
                    </div>
                    <template #footer>
                        <Button
                            label="No"
                            icon="pi pi-times"
                            class="p-button-text"
                            @click="deleteModelsDialog = false"
                        />
                        <Button
                            label="Yes"
                            icon="pi pi-check"
                            class="p-button-text"
                            @click="deleteSelectedModels"
                        />
                    </template>
                </Dialog>
            </div>
        </div>
    </div>
</template>

<script>
import AppLayout from "../../Layouts/AppLayout";
import { FilterMatchMode } from "primevue/api";
import { Head } from "@inertiajs/inertia-vue3";
import Button from "primevue/button";
import InputText from "primevue/inputtext";
import Toolbar from "primevue/toolbar";
import Toast from "primevue/toast";
import DataTable from "primevue/datatable";
import Column from "primevue/column";
import Dropdown from "primevue/dropdown";
import Calendar from "primevue/calendar";
import Textarea from "primevue/textarea";
import Badge from "primevue/badge";
import Dialog from "primevue/dialog";
import DatatableService from "../../Services/DatatableService";
import { Inertia } from "@inertiajs/inertia";
import axios from "axios";

export default {
    name: "Index",
    layout: AppLayout,
    components: {
        Head,
        Button,
        InputText,
        Toolbar,
        Toast,
        DataTable,
        Column,
        Dropdown,
        Dialog,
        Badge,
        Calendar,
        Textarea
    },
    data() {
        return {
            // Data with type data object
            filters: {},
            lazyParams: {},
            model: {},
            badgeColor: {
                'waiting': 'warning',
                'success': 'success',
                'failed': 'danger'
            },
            status: {
                'holiday': 'pi pi-star text-yellow-600',
                'present': 'pi pi-check text-green-600',
                'absent': 'pi pi-times text-red-600',
                'unshift': 'pi pi-ban text-red-800',
            },
            userDetail: JSON.parse(sessionStorage.getItem('auth:me')) ?? [],
            // Data with type data string
            searchFilter: "",
            id_user: window.location.pathname.split('/')[2],
            // data with type data boolean
            loading: true,
            submitted: false,
            selectAll: false,
            isExporting: false,
            ModalDialog: false,
            // data with type data numeric
            totalRecords: 0,
            date: 0,
            // data with type data any
            selectedModel: null,
            models: null,
            selectedModels: null,
            locations: {},
            models: null,
            editModalDialog: false,
            // model dialog
            deleteModelDialog: false,
            deleteModelsDialog: false,
            selectedModels: null,
            submitted: false,
            selectAll: false,
        };
    },
    datatableService: null,
    created() {
        this.datatableService = new DatatableService();
        this.initFilters();
        let date = new Date();
        this.currentDate(date.getFullYear(), date.getMonth())
    },
    mounted() {
        this.loading = true;
        this.lazyParams = {
            first: 0,
            rows: this.$refs.dt.rows,
            sortField: "id",
            sortOrder: -1,
            filters: this.filters,
        };
        this.loadLazyData();
        this.loadLocations();
    },
    methods: {
        // Get API
        loadLazyData() {
            this.loading = true;
            this.lazyParams = {
                ...this.lazyParams,
                where: {
                    'user_id': this.id_user,
                }
            }
            this.datatableService
                .getData(this.route("api.overtime-apply.getdata"), this.lazyParams)
                .then((data) => {
                    this.models = data.data;
                    this.totalRecords = data.total;
                    this.loading = false;
                });
        },
        loadLocations() {
            axios.get(this.route('api.location.index'))
                .then((data) => {
                    this.locations = data.data.data.data
                })
                .catch((err) => {
                    console.log(err)
                })
        },
        // Page Action
        onRowSelect() {
            this.selectAll = this.selectedModels.length === this.totalRecord;
        },
        onRowUnselect() {
            this.selectAll = false;
        },
        onPage(event) {
            this.lazyParams = event;
            this.loadLazyData();
        },
        onSort(event) {
            this.lazyParams = event;
            this.loadLazyData();
        },
        onFilter(event) {
            this.lazyParams = event;
            this.loadLazyData();
        },
        hideDialog() {
            this.ModalDialog = false;
            this.editModalDialog = false;
            this.model = {};
        },
        modalDialog() {
            this.ModalDialog = true;
        },
        editDialog(model) {
            this.model = {
                ...model,
                tanggal: new Date(model.tanggal.as),
            }
            this.editModalDialog = true;
        },
        // Action methods
        save() {
            const { tanggal_mulai, tanggal_akhir, location } = this.model
            const data = {
                user_id: this.id_user,
                jarak_masuk: location.radius,
                long_masuk: location.office_lat,
                lat_masuk: location.office_long,
                long_keluar: location.office_lat,
                lat_keluar: location.office_long,
                jarak_keluar: location.radius,
                tanggal_mulai: tanggal_mulai,
                tanggal_akhir: tanggal_akhir
            }

            axios
                .post(this.route('api.overtime-apply.store'), data)
                .then(() => {
                    this.$toast.add({
                        severity: "success",
                        summary: "Successful",
                        detail: "Overtime Success created",
                        life: 3000,
                    });
                    this.loadLazyData();
                })
                .catch((error) => {
                    this.$toast.add({
                        severity: "error",
                        summary: "Error",
                        detail: "Overtime failed created",
                        life: 3000,
                    });
                })
            this.hideDialog()
        },
        editSave() {
            const { tanggal } = this.model
            const data = {
                tanggal
            }

            axios
                .patch(`${this.$page.props.appUrl}api/api-overtime-apply/${this.id_user}`, data)
                .then(() => {
                    this.$toast.add({
                        severity: "success",
                        summary: "Successful",
                        detail: "Overtime Success updated",
                        life: 3000,
                    });
                    this.loadLazyData();
                })
                .catch((error) => {
                    this.$toast.add({
                        severity: "error",
                        summary: "Error",
                        detail: "Overtime failed created",
                        life: 3000,
                    });
                })
            this.hideDialog()
        },
        confirmDeleteModel(model) {
            this.model = model;
            this.deleteModelDialog = true;
        },
        deleteModel() {
                axios
                    .delete(this.route('api.overtime-apply.destroy', this.model.id))
                    .then((response) => {
                        this.$toast.add({
                            severity: "success",
                            summary: "Successful",
                            detail: "User Deleted",
                            life: 3000,
                        });
                        this.deleteModelDialog = false;
                        this.model = {};
                        this.loadLazyData();
                    })
                    .catch((error) => {
                        this.$toast.add({
                            severity: "error",
                            summary: "Error",
                            detail: "User not deleted",
                            life: 3000,
                        });
                    });
        },
        confirmDeleteSelected() {
            this.deleteModelsDialog = true;
        },
        deleteSelectedModels() {
            this.models = this.models.filter(
                (val) => !this.selectedModels.includes(val)
            );
            this.deleteModelsDialog = false;
            this.selectedModels = null;
            this.$toast.add({
                severity: "success",
                summary: "Successful",
                detail: "Models Deleted",
                life: 3000,
            });
        },
        // Initiation Filter
        initFilters() {
            this.filters = {
                global: { value: null, matchMode: FilterMatchMode.CONTAINS, field: 'user.name' },
            };
        },
        // Current Date
        currentDate(year, month) {
            this.date = new Date(year, month, 0).getDate();
        }
    },
};
</script>
<style scoped lang="scss">
@import "../../../assets/demo/badges.scss";
</style>
